import React from 'react'
import { FormatOptionLabelMeta } from 'react-select'
import { RecipientRow } from '../../../generated/api/chat-recipients'
import { AvatarInner } from '../../common/Avatar'
import { theme } from '../../../theme/theme'

export interface RecipientOption {
  value: string
  label: string
  recipient?: RecipientRow
  isHint?: boolean
}

export const HINT_OPTION_VALUE = '__recipients-hint__'

export const recipientFullName = (recipient: {
  firstName?: string
  lastName?: string
}): string =>
  [recipient.firstName, recipient.lastName].filter(Boolean).join(' ')

export const toRecipientOption = (
  recipient: RecipientRow
): RecipientOption => ({
  value: recipient.userId,
  label: recipientFullName(recipient),
  recipient,
})

export const toHintOption = (label: string): RecipientOption => ({
  value: HINT_OPTION_VALUE,
  label,
  isHint: true,
})

export const formatRecipientOptionLabel = (
  option: RecipientOption,
  { context }: FormatOptionLabelMeta<RecipientOption>
): JSX.Element => {
  if (option.isHint) {
    return (
      <p style={theme.textVariants.caption} className="text-neutral-50">
        {option.label}
      </p>
    )
  }

  const { recipient } = option
  if (context !== 'menu') {
    return (
      <p translate="no" style={theme.textVariants.base}>
        {option.label}
      </p>
    )
  }

  return (
    <div className="flex items-center gap-3">
      <AvatarInner
        alt={`${option.label} avatar`}
        url={recipient?.avatarUrl}
        initials={recipient?.initials}
        size={40}
      />
      <div className="flex flex-col">
        <p translate="no" style={theme.textVariants.base}>
          {option.label}
        </p>
        {recipient?.unitLabel && (
          <p style={theme.textVariants.caption} className="text-neutral-50">
            {recipient.unitLabel}
          </p>
        )}
      </div>
    </div>
  )
}
